import { isNullOrEmpty } from 'modules/app/reactComponents/packing/sanitization-steps/components/presentation/validationsFunctions'
import * as R from 'ramda'

export const isNotNullOrEmpty = v => !isNullOrEmpty(v)

